import './index.scss'

$(".section1 .content1 ul li").hover(function() {
    $(this).addClass("active1").siblings().addClass("active2");
},function() {
    $(".section1 .content1 ul li").removeClass("active1");
    $(".section1 .content1 ul li").removeClass("active2");
})